// src/components/PremiumCanceled/PremiumCanceledMobile.jsx
import { useContext, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import MobileHeader from "./headers/MobileHearder";

export default function PremiumCanceledMobile() {
  const { translate } = useContext(LanguageContext);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("⚠️ User arrived on cancel page (mobile):", currentUser?.uid);
  }, [currentUser]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
        }}
      >
        <MobileHeader
          title={translate("PaymentCanceledTitle")}
          showProfileItem={false}
        />
      </Box>

      <Box
        sx={{
          minHeight: "60vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
        }}
      >
        <CancelOutlinedIcon sx={{ fontSize: 72, color: "error.main", mb: 2 }} />
        <Typography variant="h5" gutterBottom>
          {translate("PaymentCanceledTitle")}
        </Typography>
        <Typography
          variant="body2"
          align="center"
          sx={{ mb: 3, color: "text.secondary" }}
        >
          {translate("PaymentCanceledMessage")}
        </Typography>
        <Button
          variant="outlined"
          size="large"
          onClick={() => navigate("/app/gotopremium")}
        >
          {translate("TryAgain")}
        </Button>
      </Box>
    </Box>
  );
}
